import { render } from "./NewChat.vue?vue&type=template&id=7864b85e&scoped=true&ts=true"
import script from "./NewChat.vue?vue&type=script&lang=ts"
export * from "./NewChat.vue?vue&type=script&lang=ts"

import "./NewChat.vue?vue&type=style&index=0&id=7864b85e&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7864b85e"]])

export default __exports__